document.addEventListener('DOMContentLoaded', () => {
  const cartDrawerR = document.querySelector('cart-drawer');

  if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.cart = cartDrawerR || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (this.form) {
          this.setupForm();
        }

        if (this.cart || cartDrawerR) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      setupForm() {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

 async onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');

  if (typeof openMainPreCartDrawer === 'function') {
    openMainPreCartDrawer();
  }

  if (this.querySelector('.loading-overlay__spinner')) {
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  }

  const productTags = this.dataset.tags ? JSON.parse(this.dataset.tags) : [];
  const isCrossSell1 = productTags.includes('cross1');
  const crossSell2VariantId = window.crossSellProduct2VariantId;

  // --- НОВОЕ ИЗМЕНЕНИЕ ЗДЕСЬ ---
  // Проверяем, есть ли в корзине товары, исключающие добавление cross2
  const cartHasExclusionItem = document.querySelector('cart-drawer .pdm1, cart-drawer .giftpack');

  let requestBody;
  const config = fetchConfig('javascript');

  // Условие теперь проверяет не только cross1, но и отсутствие запрещающих товаров
  if (isCrossSell1 && crossSell2VariantId && !cartHasExclusionItem) {
    config.headers['Content-Type'] = 'application/json';

    const mainVariantId = this.form.querySelector('[name=id]').value;
    const mainQuantity = parseInt(this.form.querySelector('[name=quantity]').value || 1);

    requestBody = JSON.stringify({
      items: [
        { id: mainVariantId, quantity: mainQuantity },
        { id: crossSell2VariantId, quantity: 1 }
      ],
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
  } else {
    // Стандартная логика для добавления ОДНОГО товара (сработает для cross1, если в корзине есть pdm/giftpack)
    delete config.headers['Content-Type'];
    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    requestBody = formData;
  }

  config.body = requestBody;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }
      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }
      this.handleSuccessfulSubmission(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      if (this.querySelector('.loading-overlay__spinner')) {
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    });
}

      handleErrorMessage(errorMessage = false) {
        const errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
        if (errorMessageWrapper) {
          const errorMessageElement = errorMessageWrapper.querySelector('.product-form__error-message');
          errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          if (errorMessage) {
            errorMessageElement.textContent = errorMessage;
          }
        }
      }

      handleSuccessfulSubmission(response) {
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');

        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              this.cart.renderContents(response);
              realCount();
              setTimeout(async () => {
    const languageNow = document.querySelector('.header__lang-current').textContent;
    const trimmedLanguageNow = languageNow.trim();
    
    let url;

    switch (trimmedLanguageNow) {
        case 'FR':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/FR_reworked_10da3f31-fe31-4eff-88e1-195b6b8f5117.json?v=1703053371';
            break;
        case 'DE':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/DE_reworked_8701a2f1-6a7e-47ad-90a7-1ad0059604d7.json?v=1703053371';
            break;
        case 'RU':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/RU_reworked_74779b34-6f7a-446f-a0c9-b96ebaac6629.json?v=1703053371';
            break;
        case 'IT':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/IT_reworked_3_9e4f39a7-1ff5-428f-bd6f-efac51e4825b.json?v=1703053370';
            break;
        case 'CN':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/CN_reworked_43a655ec-c7da-4c6b-9e0d-55a15e4c7f70.json?v=1703053371';
            break;
        default:
            break;
    }

    if (url) {
        const response = await fetch(url);
        const data = await response.json();
        TranslationDrawer(data);
    }
});
            });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
          realCount();
          setTimeout(async () => {
    const languageNow = document.querySelector('.header__lang-current').textContent;
    const trimmedLanguageNow = languageNow.trim();
    
    let url;

    switch (trimmedLanguageNow) {
        case 'FR':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/FR_reworked_10da3f31-fe31-4eff-88e1-195b6b8f5117.json?v=1703053371';
            break;
        case 'DE':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/DE_reworked_8701a2f1-6a7e-47ad-90a7-1ad0059604d7.json?v=1703053371';
            break;
        case 'RU':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/RU_reworked_74779b34-6f7a-446f-a0c9-b96ebaac6629.json?v=1703053371';
            break;
        case 'IT':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/IT_reworked_3_9e4f39a7-1ff5-428f-bd6f-efac51e4825b.json?v=1703053370';
            break;
        case 'CN':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/CN_reworked_43a655ec-c7da-4c6b-9e0d-55a15e4c7f70.json?v=1703053371';
            break;
        default:
            break;
    }

    if (url) {
        const response = await fetch(url);
        const data = await response.json();
        TranslationDrawer(data);
        TranslationFormButtons(data);
    }
});
        }
      }
    });
  }
});
